import routes from '@/modules/complain/complain-routes';
import store from '@/modules/complain/complain-store';

export default {
    routes,
    store,
}
